module.exports = "/_next/static/images/346a557a0b7f817186d1816d3527409d-nubank-indoor-pool@lg-2x.jpg.webp";